module.exports = __webpack_public_path__ + "static/sportex-result-2-c8c165490bc7c8285daf03a521441ac3.png";